import { PayloadAction } from '@reduxjs/toolkit';
import { message } from 'antd';
import { DownloadScoredFilePayload } from 'features/Yucollect/Score/types/Score.types';
import { downloadExcelFile } from 'features/Yucollect/utils/util';
import { put, takeLatest } from 'redux-saga/effects';
import {
  downloadScoredFileFailure,
  downloadScoredFileReq,
  downloadScoredFileSuccess,
} from 'redux/slice/score/DownloadScoredFile.slice';
import { scoreEndpoints } from 'services/api/endPoints';
import { HTTPClient } from 'services/api/http-client';

function* downloadScoredFileSaga({
  payload,
}: PayloadAction<DownloadScoredFilePayload>) {
  try {
    const { allocationId, allocationName } = payload;
    const response: { data: Blob } = yield HTTPClient.DownloadRequest(
      scoreEndpoints.DOWNLOAD_SCORED_FILE(allocationId)
    );
    yield put(downloadScoredFileSuccess());
    downloadExcelFile(response.data, `${allocationName}_scored.xlsx`);
    message.success('Scored file downloaded successfully');
  } catch {
    yield put(downloadScoredFileFailure('Failed to download scored file'));
    message.error('Failed to download scored file');
  }
}

export function* watchDownloadScoredFileSagas() {
  yield takeLatest(downloadScoredFileReq.type, downloadScoredFileSaga);
}
